import { SocialValidation as RawSocialValidation } from '../../../components/landingPage/SocialValidation';
import React from 'react';
import { SanityObject } from '../../../lib/landingPage';
import { IconLabel, IconLabelProps } from '../IconLabel';
import { Wrapper } from '../Wrapper';
import { Image, ImageProps } from '../Image';

type ImageSetProps = {
    images: SanityObject<ImageProps>[];
};

export type SocialValidationProps = {
    logoSet: SanityObject<ImageSetProps>;
    labels?: SanityObject<IconLabelProps>[];
    title: string;
};

export const SocialValidation = Wrapper(
    ({ logoSet, labels, title }: SocialValidationProps): JSX.Element => {
        return (
            <RawSocialValidation
                title={title}
                labels={
                    labels && labels.length > 0 ? (
                        <IconLabel value={labels} />
                    ) : undefined
                }>
                <Image value={logoSet.images} />
            </RawSocialValidation>
        );
    },
    'socialValidation'
);
